import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchUsers = createAsyncThunk("users/fetchUsers", async () => {
  try {
    const response = await axios.get(
      "https://api.generalhome.sa/api/Authenticate/GetAllUsers"
    );

    const fixedData = response.data.map((item) => {
      // Replace old domain with the new one
      const oldDomain = "https://aircon-api.hiveagency.tech";
      const newDomain = "https://api.generalhome.sa";

      return {
        ...item,
        Image: item.Image?.startsWith(oldDomain)
          ? item.Image.replace(oldDomain, newDomain)
          : item.Image,
      };
    });

    return fixedData;
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
});

// Fetch permissions for a specific user
export const fetchUserPermissions = createAsyncThunk(
  "users/fetchUserPermissions",
  async (userId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `https://api.generalhome.sa/api/Authorization/GetUserPermissions/${userId}`
      );
      return data;
    } catch (error) {
      console.error("Error fetching user permissions:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const usersSlice = createSlice({
  name: "users",
  initialState: {
    list: [],
    selectedUser: null,
    userPermissions: {},
    loading: false,
    loadingPermissions: false,
    error: null,
    permissionsError: null,
  },
  reducers: {
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
    resetUserPermissions: (state) => {
      state.userPermissions = {};
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch users
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // Fetch user permissions
      .addCase(fetchUserPermissions.pending, (state) => {
        state.loadingPermissions = true;
        state.permissionsError = null;
      })
      .addCase(fetchUserPermissions.fulfilled, (state, action) => {
        state.loadingPermissions = false;
        state.userPermissions = action.payload;
      })
      .addCase(fetchUserPermissions.rejected, (state, action) => {
        state.loadingPermissions = false;
        state.permissionsError = action.payload;
      });
  },
});

export const { setSelectedUser, resetUserPermissions } = usersSlice.actions;
export default usersSlice.reducer;
